import { render, staticRenderFns } from "./modelDesigner.vue?vue&type=template&id=546c5c50"
import script from "./modelDesigner.vue?vue&type=script&lang=js"
export * from "./modelDesigner.vue?vue&type=script&lang=js"
import style0 from "./modelDesigner.vue?vue&type=style&index=0&id=546c5c50&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports